




import Vue from 'vue';
import ContentDelete from '@/components/content/content-delete.component.vue';

export default Vue.extend({
  components: {
    'content-delete': ContentDelete,
  },
});
